import React from "react";
import { MapPin } from "@phosphor-icons/react";

import {
  Panel,
  PanelAction,
  PanelBadge,
  PanelRow,
  PanelRows,
} from "../../../design-system/patterns/settings";

const formatAddress = (addr) =>
  [
    addr?.address_line1,
    addr?.address_line2,
    addr?.city,
    addr?.province,
    addr?.postal_code,
  ]
    .filter(Boolean)
    .join(", ");

/**
 * The buyer's delivery address, read only. Pure.
 *
 * A buyer edits this through the profile dialog, which is why the panel's one
 * action opens that dialog rather than a second address form.
 */
const AddressSection = ({ address, onEdit }) => (
  <Panel
    icon={MapPin}
    title="Address information"
    action={<PanelAction onClick={onEdit}>Edit address</PanelAction>}
  >
    <PanelRows>
      <PanelRow
        title={address?.city || "Home"}
        badge={<PanelBadge>Default</PanelBadge>}
        detail={formatAddress(address) || "No address provided"}
      />
    </PanelRows>
  </Panel>
);

export default AddressSection;
